import { createFileRoute } from "@tanstack/react-router";
import { FileFormats } from "../../app/helpers/resultUploadHelper";
import Upload from "../../app/views/resultUpload";

const PcrUpload = () => <Upload enabledFormats={[FileFormats.PCR]} />;

export const Route = createFileRoute("/pcr/upload")({
  component: PcrUpload,
});
